import QuestionPage from "./question-page";

export default class Controls {
	constructor($root, mainController) {
		this.$root = $root;
		this.$answersSection = this.$root.querySelector('.quiz-options');
		this.$nextBtn = this.$root.querySelector('.quiz_next');
		this.$prevBtn = this.$root.querySelector('.quiz_prev');

		this.isInitialized = false;

		/* Components */
		this.mainController = mainController;
		this.questionPage = null;
	}

	init(switchPageCallback) {
		if (!this.isInitialized) {
			Controls.prototype.switchPage = switchPageCallback;
			this.questionPage = new QuestionPage(this.$root, this.mainController);
			this.addListeners();
			this.isInitialized = true;
		}

		this.questionPage.init();
		this.refreshButtonsSettings();
	}

	addListeners() {
		this.addNextBtnListener();
		this.addPrevBtnListener();
		this.addSwitchAnswerListener();
	}

	addNextBtnListener() {
		this.$nextBtn.addEventListener('click', e => {
			e.preventDefault();

			this.questionPage.saveUserAnswer();
			this.mainController.setAnimationState();

			if (this.mainController.isLastQuestion) {
				this.finishTest();
			} else {
				this.mainController.animation.next(() => {
					this.questionPage.switchQuestionPage('next');
					this.refreshButtonsSettings();
				});
			}
		});
	}

	finishTest() {
		const userData = this.mainController.getUserData();
		if (userData !== null) {
			this.questionPage.sendForm(userData);
			userData['fromStorage'] = true;
			this.mainController.finishQuiz(userData);
			this.switchPage('next', 'last');
		} else {
			this.switchPage('next');
		}
	}

	addPrevBtnListener() {
		this.$prevBtn.addEventListener('click', e => {
			e.preventDefault();

			if (this.mainController.isFirstQuestion && this.mainController.isMultiple) {
				this.switchPage('prev', 1);
			} else {
				this.mainController.animation.prev(() => {
					this.questionPage.switchQuestionPage('prev');
					this.mainController.setAnimationState();
					this.refreshButtonsSettings();
				});
			}
		});
	}

	addSwitchAnswerListener() {
		this.mainController.registerEvent('switchAnswer', 'keydown', window, e => {
			this.$controlsList.forEach(($item) => {
				const $option = $item.closest('.quiz-options_item');
				const key = +$option.dataset.id + 1 + '';

				if (e.key === key) {
					const $input = $item.querySelector('input');
					$input.checked = true;
					$input.dispatchEvent(new Event('change'));
				}
			});
		});
	}

	refreshButtonsSettings() {
		this.activateNextBtn();
		this.activatePrevBtn();
		this.addChooseAnswerListener();
	}

	addChooseAnswerListener() {
		this.$controlsList = this.$answersSection.querySelectorAll('.radio, .checkbox');

		this.$controlsList.forEach(($control) => {
			const $input = $control.querySelector('input');
			$input.addEventListener('change', e => {
				this.$controlsList.forEach(($item) => {
					const $input = $item.querySelector('input');
					if ($input.checked) {
						$input.closest('label').classList.add('checked');
					} else {
						$input.closest('label').classList.remove('checked');
					}
				});

				this.activateNextBtn();
			});
		});
	}

	activateNextBtn() {
		const isLast = this.mainController.isLastQuestion;
		const nextBtnText = isLast ?
			craft.localization.sendTest :
			craft.localization.nextQuestion;
		this.$nextBtn.textContent = nextBtnText;

		const isAnswered = this.isAnswerSelected();
		if (isAnswered) {
			this.$nextBtn.removeAttribute('disabled');
			this.$nextBtn.classList.remove('-disabled');
		} else {
			this.$nextBtn.setAttribute('disabled', 'disabled');
			this.$nextBtn.classList.add('-disabled')
		}
	}

	activatePrevBtn() {
		const isFirst = this.mainController.isFirstQuestion,
			isMultiple = this.mainController.isMultiple;

		if (isFirst && !isMultiple) {
			this.$prevBtn.setAttribute('disabled', 'disabled');
			this.$prevBtn.classList.add('-disabled');
		} else {
			this.$prevBtn.removeAttribute('disabled');
			this.$prevBtn.classList.remove('-disabled');
		}
	}

	isAnswerSelected() {
		return this.$answersSection.querySelectorAll('.checked').length !== 0;
	}
}